import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { abstractChart } from '../abstractChart';

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  standalone: false,
})
export class PieChartComponent extends abstractChart {
  @ViewChild('chart') chart: ElementRef<HTMLCanvasElement> | undefined;
  @Input() label: string = '';

  constructor() {
    super('pie', true);
  }

  getLabel(): string {
    return this.label;
  }

  getGraph(): ElementRef<HTMLCanvasElement> | undefined {
    return this.chart;
  }
}
